import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { TypographyHeading } from "shared/molecules/typography-layout";
import entitesClient from "utils/graphql/entitiesClient";
import { GET_PRODUCTS_LIST, GET_VENDOR_ACCOUNTS, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import { Box, InputLabel, MenuItem, Pagination, Paper, Select, Stack, FormControl } from "@mui/material";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import NoDataFound from "shared/molecules/no-data";
import { table } from './helper'
import { VendorAccountFilter } from "./filter";
import liveClassClientService from "utils/graphql/liveclassClient";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { utcToIst } from "utils/time-util/utcIstTime";

export default function VendorAccounts() {

  const [searchPayload, setSearchPayload] = useState({});
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [clearValuesTrigger, setClearValuesTrigger] = useState("")

  const [getVendorAccountList, { loading, error, data }] = useLazyQuery(
    GET_VENDOR_ACCOUNTS,
    {
      client: liveClassClientService,
    }
  )

  useEffect(() => {
    getVendorAccountList({
      variables: {
        input: {
          limit: limit,
          offset: (page - 1) * limit,
          ...searchPayload,
        },
      },
    });
  }, [page, limit, searchPayload])

  const vendorAccountsData =
    data?.getVendorAccounts?.vendorAccounts?.map((item: any) => ({
      ...item,
      createdAt: utcToIst(item.createdAt),
      updatedAt: utcToIst(item.updatedAt),
    })) || [];
    
//  if (showLoading) return <p>Loading...</p>;
  return (
    <>
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Vendors Accounts{" "}
      </TypographyHeading>

      <VendorAccountFilter
        setSearchPayload={setSearchPayload}
        setPage={setPage}
        clearValuesTrigger={clearValuesTrigger}
      />

      <Paper elevation={2} sx={{ p: 2, mt: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <FormControl size="small" sx={{ width: 140 }}>
            <InputLabel>Show Entries</InputLabel>
            <Select
              value={limit}
              label="Show Entries"
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1); // reset to first page
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={500}>500</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <div>
          {loading && <Loader />}
          {!loading && data?.getVendorAccounts?.vendorAccounts?.length > 0 ? (
            <SectionTable
              data={vendorAccountsData || []}
              table={table}
              id="id"
              name="id"
              rowsPerPageCount={limit}
              style="false"
              totalRecords={data?.getVendorAccounts?.totalCount || 0}
              paginationSegment="false"
              viewSecondaryData="false"
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data Found" />}</div>
          )}
        </div>

        <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={
                Math.ceil(data?.getVendorAccounts?.totalCount / limit) || 1
              }
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
      </Paper>
    </>
  );
}
